import React, { useContext, useEffect, useState } from "react";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { context } from "../context/context";
import EventCommentsTable from "../components/Events/EventCommentsTable";
import { NavLink } from "react-router-dom";
import { Button } from "antd";

const EventComments = () => {
    // state
    const [comments, setComments] = useState([]);
    const [title, setTitle] = useState();
    const [loading, setLoading] = useState(false);
    // context
    const { selectedEventId } = useContext(context);
    // useEffect
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Event/${selectedEventId}`)
            .then((res) => {
                setLoading(false);
                setTitle(res.data.result.title);
                setComments(res.data.result.comment);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    }, [selectedEventId]);

    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3>کامنت های {title}</h3>
                {
                    <NavLink to="/events">
                        <Button type="primary" danger>
                            بازگشت
                        </Button>
                    </NavLink>
                }
            </div>
            <EventCommentsTable comments={comments} loading={loading} />
        </>
    );
};

export default EventComments;
